import {
  GetFwLaborCostsConceptsDocument,
  GetFwLaborCostsConceptsQuery,
} from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

export interface ReturnedData {
  concepts: GetFwLaborCostsConceptsQuery['payroll']['concepts']
  currentAssignedLaborCost: GetFwLaborCostsConceptsQuery['payroll']['concepts'][number] | undefined
  loading: boolean
  refetch: () => void
}

const DEFAULT_CONCEPT_NAME = 'company_cost'

export const useLaborCostConcepts = (): ReturnedData => {
  const { data, refetch, loading } = useQuery(GetFwLaborCostsConceptsDocument)

  const currentAssignedLaborCost = useUnsafeMemo(() => {
    const conceptWithLaborCost = data?.payroll?.concepts.find((concept) => concept.laborCost)

    if (conceptWithLaborCost) {
      return conceptWithLaborCost
    }

    return data?.payroll?.concepts.find(
      (concept) => concept.default && concept.name === DEFAULT_CONCEPT_NAME
    )
  }, [data])

  return {
    concepts: orderBy(data?.payroll?.concepts, 'translatedName') ?? [],
    currentAssignedLaborCost,
    loading,
    refetch,
  }
}
